module.exports = __webpack_public_path__ + "img/skating.6558c5c9.png";